import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import TopNav from "./components/shared/TopNav";
import Footer from "./components/shared/Footer";
import IstarDelete from "./pages/IstarDelete";
import IstarPrivacy from "./pages/IstarPrivacy";
import FoyerPrivacy from "./pages/FoyerPrivacy";
import FoyerDelete from "./pages/FoyerDelete";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <TopNav />
        <main className="flex-grow">
          <Routes>
            <Route path="/" caseSensitive={false} element={<Home />} />
            <Route path="/home" caseSensitive={false} element={<Home />} />
            {/* <Route path="/services" caseSensitive={false} element={<Services />} /> */}
            {/* <Route path="/about" caseSensitive={false} element={<About />} /> */}
            {/* <Route path="/contact" caseSensitive={false} element={<Contact />} /> */}
            <Route
              path="/istar/delete"
              caseSensitive={false}
              element={<IstarDelete />}
            />
            <Route
              path="/istar/privacy"
              caseSensitive={false}
              element={<IstarPrivacy />}
            />
            <Route
              path="/foyer/privacy"
              caseSensitive={false}
              element={<FoyerPrivacy />}
            />
            <Route
              path="/foyer/delete"
              caseSensitive={false}
              element={<FoyerDelete />}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
